<!-- 商品购买 -->
<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      v-if="dataType != 'itemTag'"
      prop="skuId"
      :label="firstColumnLabel"
      width="180"
      align="center"
    >
    </el-table-column>
    <template v-if="dataType == 'itemTag'">
      <el-table-column
        v-for="(item, index) in tableOrderList"
        :key="index + item.label"
        :label="item.label"
        :prop="item.prop"
        align="center"
      >
        <el-table-column
          :prop="childrenItem.prop"
          :label="childrenItem.label"
          :min-width="childrenItem.width ? childrenItem.width : '80'"
          fixed
          v-for="(childrenItem, childrenIndex) in item.childrenProps"
          :key="childrenItem.label + childrenIndex"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row[childrenItem.prop] }}
          </template>
        </el-table-column>
      </el-table-column>
    </template>
    <template v-if="dataType != 'itemTag'">
      <el-table-column
        prop="skuName"
        :label="secondColumnLabel"
        width="180"
        align="center"
      >
        <template slot-scope="{ row }">
          <textOverflowTooltip :content="row.skuName" :lines="1" />
        </template>
      </el-table-column>
    </template>
    <el-table-column
      align="center"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      v-for="(item, index) in tabledataList"
    >
      <el-table-column
        align="right"
        :prop="childrenItem.prop"
        :label="childrenItem.label"
        :min-width="childrenItem.width ? childrenItem.width : '80'"
        v-for="(childrenItem, childrenIndex) in item.childrenProps"
        :key="childrenItem.label + childrenIndex"
      >
        <template slot-scope="{ row }">
          <span>{{ row[childrenItem.prop] }}</span>
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import mixins from "../../../mixins/index.js";
import dayjs from "dayjs";
import Empty from "../../../components/empty.vue";
export default {
  name: "storeProductCom",
  mixins: [mixins],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
    payTimeStart: {
      type: String,
      default: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    },
    payTimeEnd: {
      type: String,
      default: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    },
    reportParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tabledataList: [],
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.getTableInfo(newVal);
      },
      immediate: true,
    },
  },
  components: {
    Empty,
    textOverflowTooltip: () =>
      import(
        "@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"
      ),
  },
  computed: {
    cascadeItemTagClassifyType() {
      return this.reportParams.cascadeItemTagClassifyType || 0;
    },
    cascadeItemTagClassifyNameList() {
      return this.reportParams.cascadeItemTagClassifyNameList || [];
    },
    firstColumnLabel() {
      const map = {
        sku: "skuId",
        spu: "商品spu",
        category: "类目Id",
        sellerCategory: "类目Id",
      };
      return map[this.dataType] || "";
    },
    secondColumnLabel() {
      const map = {
        sku: "商品名称",
        spu: "商品名称",
        category: "类目名称",
        sellerCategory: "类目名称",
      };
      return map[this.dataType] || "";
    },
    countTable() {
      return this.tableData.map((item) => {
        const row = {
          skuId: item.skuId, // 根据需求可能是 skuId
          skuName: item.skuName,
          classifyName: item.classifyName,
          paymentCount: this.formatNumber(item.paymentCount),
          paymentAmount: this.formatNumber(item.paymentAmount),
          purchaseTimes: this.formatNumber(item.purchaseTimes),
          paymentItemCount: this.formatNumber(item.paymentItemCount),
          storeRepurchaseCount: this.formatNumber(item.storeRepurchaseCount),
          storeRepurchaseRatio: this.formatPercent(item.storeRepurchaseRatio),
          storeRepurchaseAmount: this.formatNumber(item.storeRepurchaseAmount),
          storeRepurchaseItemCount: this.formatNumber(
            item.storeRepurchaseItemCount
          ),
          storeRepurchaseTimes: this.formatNumber(item.storeRepurchaseTimes),
          averageIntervalDays: this.formatNumber(item.averageIntervalDays), // 保留两位小数
        };
        // 级联模式：展开 categoryNameList
        if (item.categoryNameList && item.categoryNameList.length > 0) {
          item.categoryNameList.forEach((cat, idx) => {
            row[`category${idx}`] = cat;
          });
        }
        // 动态处理区间数据
        if (item.intervalDataList && item.intervalDataList.length > 0) {
          item.intervalDataList.forEach((interval, index) => {
            row[`intervalCount${index}`] = this.formatNumber(
              interval.intervalCount
            );
            row[`intervalRatio${index}`] = this.formatPercent(
              interval.intervalRatio
            );
          });
        }
        return row;
      });
    },
    tableOrderList() {
      if (this.cascadeItemTagClassifyType) {
        // 级联模式：动态生成级联列
        const cascadeProps = this.cascadeItemTagClassifyNameList.map(
          (item, index) => {
            return {
              prop: `category${index}`,
              label: item,
              width: "120",
            };
          },
        );
        return [
          {
            label: "商品标签",
            childrenProps: cascadeProps,
          },
        ];
      }
      return [
        {
          label: "商品标签",
          childrenProps: [
            {
              prop: "classifyName",
              label: "标签分类",
              width: "120",
            },
            {
              prop: "skuName",
              label: "标签名称",
              width: "120",
            },
          ],
        },
      ];
    }
  },
  methods: {
    getTableInfo(data = []) {
      // 如果没有数据或者数据中没有区间列表，使用默认配置
      let intervalList = [];
      if (data && data.length > 0 && data[0].intervalDataList) {
        // 使用第一条数据的区间信息来构建表头
        intervalList = data[0].intervalDataList;
      }
      let boundarieHeaderList = [];
      // 优先使用数据中的区间信息
      if (intervalList.length > 0) {
        boundarieHeaderList = intervalList.map((item, index) => {
          return {
            label: item.intervalRange,
            childrenProps: [
              {
                prop: `intervalCount${index}`,
                label: "人数",
                width: 100,
              },
              {
                prop: `intervalRatio${index}`,
                label: "占比",
                width: 100,
              },
            ],
          };
        });
      }
      this.tabledataList = [
        // 固定列
        {
          label: `${this.payTimeStart || ""}至${this.payTimeEnd || ""}`,
          childrenProps: [
            {
              prop: "paymentCount",
              label: "付款人数",
              width: 100,
            },
            {
              prop: "paymentAmount",
              label: "付款金额",
              width: 120,
            },
            {
              prop: "purchaseTimes",
              label: "购买次数",
              width: 100,
            },
            {
              prop: "paymentItemCount",
              label: "付款件数",
              width: 100,
            },
            {
              prop: "storeRepurchaseCount",
              label: "店铺复购人数",
              width: 140,
            },
            {
              prop: "storeRepurchaseRatio",
              label: "店铺复购率",
              width: 140,
            },
            {
              prop: "storeRepurchaseAmount",
              label: "店铺复购金额",
              width: 140,
            },
            {
              prop: "storeRepurchaseItemCount",
              label: "店铺复购件数",
              width: 140,
            },
            {
              prop: "storeRepurchaseTimes",
              label: "店铺复购次数",
              width: 140,
            },
            {
              prop: "averageIntervalDays",
              label: "平均间隔天数",
              width: 140,
            },
          ],
        },
        ...boundarieHeaderList,
      ];
    },
    objectSpanMethod({ row, rowIndex, column, columnIndex }) {
      if(rowIndex == 0 && this.dataType != "itemTag"){
        let spanArr = ['skuId', 'skuName']
        if (row[spanArr[0]] == "合计" && row[spanArr[1]] == "合计") {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 2 };
          }
          if (columnIndex === 1) {
            return { rowspan: 0, colspan: 0 };
          }
        } 
      }
      // 非商品标签维度不需要合并
      if (this.dataType != "itemTag") return;
      if (this.cascadeItemTagClassifyType) {
        // if(rowIndex == 0){
        //   let props = ['skuId', 'skuName']
        //   let isTotal = row[props[0]] == '合计' && row[props[1]] == '合计'
        //   if(isTotal){
        //     if((columnIndex < this.cascadeItemTagClassifyNameList.length) && columnIndex != 0){
        //       return {
        //         rowspan: 0,
        //         colspan: 0,
        //       }
        //     }
        //     if(columnIndex === 0){
        //      return {
        //        rowspan: 1,
        //        colspan: this.cascadeItemTagClassifyNameList.length
        //      };
        //     }
        //   }
        // }
        // 级联模式：按 column.property 动态合并相同值
        // const prop = column.property;
        // if (!prop || !prop.startsWith("category")) return;
        // const list = this.countTable;
        // let rowspan = 1;
        // const current = row[prop];
        // // 合计行特殊处理
        // if (current === "合计") {
        //   for (let i = rowIndex + 1; i < list.length; i++) {
        //     if (list[i][prop] === "合计") {
        //       rowspan++;
        //     } else {
        //       break;
        //     }
        //   }
        //   if (rowIndex > 0 && list[rowIndex - 1][prop] === "合计") {
        //     return { rowspan: 0, colspan: 0 };
        //   }
        //   return { rowspan, colspan: 1 };
        // }
        // // 普通相同值合并
        // for (let i = rowIndex + 1; i < list.length; i++) {
        //   if (list[i][prop] === current) {
        //     rowspan++;
        //   } else {
        //     break;
        //   }
        // }
        // if (rowIndex > 0 && list[rowIndex - 1][prop] === current) {
        //   return { rowspan: 0, colspan: 0 };
        // }
        // return { rowspan, colspan: 1 };
      } else {
        // 并列模式：按 classifyName 合并第一列
        if (row.classifyName == "合计" && row.skuName == "合计") {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 2 };
          }
          if (columnIndex === 1) {
            return { rowspan: 0, colspan: 0 };
          }
        }
        // if (columnIndex === 0) {
        //   const current = this.countTable[rowIndex].classifyName;
        //   const prev = this.countTable[rowIndex - 1]
        //     ? this.countTable[rowIndex - 1].classifyName
        //     : null;
        //   if (current === prev) {
        //     return { rowspan: 0, colspan: 0 };
        //   }
        //   let rowspan = 1;
        //   for (let i = rowIndex + 1; i < this.countTable.length; i++) {
        //     if (this.countTable[i].classifyName === current) {
        //       rowspan++;
        //     } else {
        //       break;
        //     }
        //   }
        //   return { rowspan, colspan: 1 };
        // }
      }
    },
  },
};
</script>
